import { render, staticRenderFns } from "./RegisterBlocks.vue?vue&type=template&id=5cbb64c9&scoped=true&"
import script from "./RegisterBlocks.vue?vue&type=script&lang=ts&"
export * from "./RegisterBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterBlocks.vue?vue&type=style&index=0&id=5cbb64c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb64c9",
  null
  
)

export default component.exports